window.mockData = require('./data');
